import { Trans, useTranslation } from 'react-i18next';
import { Flex } from 'antd';
import { Button, Heading, Modal, Paragraph, Text } from '../Ant';
import { InfoCircleOutline } from '../icons';
import RunningTimerSummary from './runningTimerSummary';
import { ITimer } from '../../interface/timer';
import { SwitchOrganisationIcon } from '../../assets/styles/components/organisationSwitch.styled';
import {
  MODAL_CANCEL_BUTTON_MAX_WIDTH,
  MODAL_CONFIRM_BUTTON_MAX_WIDTH,
} from '../../constants/constants';

interface SwitchOrganisationConfirmModalProps {
  open: boolean;
  targetOrganisationName: string;
  runningTimers: ITimer[];
  onCancel: () => void;
  onConfirm: () => void;
}

const SwitchOrganisationConfirmModal = ({
  open,
  targetOrganisationName,
  runningTimers,
  onCancel,
  onConfirm,
}: SwitchOrganisationConfirmModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      className="confirm-modal"
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      closeIcon={null}
      data-testid="switch-organisation-confirm-modal"
      width={370}
    >
      <Flex vertical align="center" gap={15}>
        <SwitchOrganisationIcon justify="center" align="center">
          <InfoCircleOutline />
        </SwitchOrganisationIcon>
        <Flex vertical gap={15} className="w-full">
          <Flex vertical gap={5}>
            <Heading
              level={6}
              data-testid="switch-organisation-title"
              $fontsize="14px"
              $color="title"
              $weight={600}
              $lineheight="20px"
              className="ta-center"
            >
              {t('common:organizationSwitch.title')}
            </Heading>
            <Paragraph
              data-testid="switch-organisation-message"
              $fontsize="12px"
              $color="subtitle"
              $lineheight="18px"
              className="ta-center"
            >
              <Trans
                i18nKey="common:organizationSwitch.timerRunningMessage"
                values={{ organizationName: targetOrganisationName }}
                components={{
                  orgName: <Text $fontsize="12px" $color="subtitle" $weight={600} />,
                }}
              />
            </Paragraph>
          </Flex>
          {runningTimers.map((timer) => (
            <RunningTimerSummary key={timer.id} timer={timer} />
          ))}
        </Flex>
        <Flex gap={5} align="center" className="w-full">
          <Button
            data-testid="cancel-button"
            size="large"
            onClick={onCancel}
            block
            maxwidth={MODAL_CANCEL_BUTTON_MAX_WIDTH}
          >
            {t('common:cancel')}
          </Button>
          <Button
            data-testid="confirm-button"
            size="large"
            type="primary"
            onClick={onConfirm}
            block
            className="p-0"
            maxwidth={MODAL_CONFIRM_BUTTON_MAX_WIDTH}
          >
            {t('common:organizationSwitch.stopAndSwitch')}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default SwitchOrganisationConfirmModal;
